import React, { useState } from 'react';
import TableCustom from '../../components/common/customTable/TableCustom';
import {
  Stack,
  TableBody,
  TableCell,
  TableRow,
  TextField,
} from '@mui/material';
import { SearchBar } from '../../components/common/SearchBar';
import FilterBy from '../../components/common/FilterBy';
import { SearchFilterContainer } from '../../assets/styles/layout/searchFilter.styled';
import ChildHeader from '../../components/ui/ChildHeader';
import axios from 'axios';
import AddEditPart, { IPart } from '../addparts/AddEditPart';
import useDebounce from '../../hooks/useDebounce';
import { useAuth } from '../../services/auth/AuthProvider';
import formatDate from '../../components/common/formatDate';
import {
  EditIconButton,
  ViewIconButton,
  DeleteIconButton,
} from '../../components/common/button/CustomIconButton';
import ModalCustom from '../../components/common/Modal';
import { useQuery } from '../../hooks/UseQuery';
import { useNavigate } from 'react-router-dom';
import { CustomPagination } from '../../components/common';
import ConfirmDialogueForInput from '../../components/common/ConfirmDialogueForInput';
import TableCellStatus from './components/TableCellStatus';
import { CustomButton } from '../../components/common/button/CustomButtons';
import { RiFileExcel2Line } from 'react-icons/ri';
import { excelDownload } from './helpers/utils';
const tableHeaderObj = [
  [
    { text: '#', rowspan: 1, colspan: 1 },
    { text: 'Icpl Uid'.toUpperCase(), rowspan: 1, colspan: 1 },
    { text: 'Item Number', rowspan: 1, colspan: 1 },
    { text: 'Item Description', rowspan: 1, colspan: 1 },
    { text: 'Customer', rowspan: 1, colspan: 1 },
    { text: 'Supplier', rowspan: 1, colspan: 1 },
    { text: 'Created At', rowspan: 1, colspan: 1 },
    { text: 'Status', rowspan: 1, colspan: 1 },
    { text: 'Action', rowspan: 1, colspan: 1 },
  ],
];

const filterOptions = [
  { value: 'part_number', name: 'A-Z' },
  { value: 'createdAt', name: 'Most Recent First' },
  { value: 'createdAt_old', name: 'Oldest First' },
  { value: 'status', name: 'status' },
];

const ViewAdminPpapDoc = () => {
  const { state } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState<IPart[]>([]);
  const [isNewPartModal, setIsNewPartModal] = useState(false);
  const [render, setRender] = useState(false);
  const [dropDownRender, setDropDownRender] = useState(false);
  const [duplicateOpenModal, setDuplicateOpenModal] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [partId, setPartId] = useState<string | null>('');
  const [itemPartNumber, setItemPartNumber] = useState<string | null>(null);
  const [confirmOpenForDelete, setConfirmOpenForDelete] = useState(false);
  const [textFieldValue, setTextFieldValue] = useState<string | null>(null);

  const search = useQuery('search');
  const filter = useQuery('filter');
  const page = useQuery('page') || 1;

  const fetchData = async () => {
    const res: any = await axios
      .get(
        `/api/addPartRoute/byDocType/publish?page=${page}&sortBy=${filter}&search=${search}&perPage=${10}`,
      )
      .catch((err) => {
        console.log(err);
      });
    // console.log(res.data?.result)
    setData(res.data?.result);
    setPerPage(res.data?.perPage);
    setTotalPages(res.data?.pages);
  };

  useDebounce(fetchData, 1000, [
    page,
    search,
    render,
    filter,
    duplicateOpenModal,
    isNewPartModal,
  ]);
  const deletePart = async (id: string) => {
    await axios.delete(`/api/addPartRoute/${id}`);
    setRender((prev) => !prev);
  };

  const handleDialogWithInput = () => {
    if (!partId) return;
    if (itemPartNumber === textFieldValue) {
      deletePart(partId);
      setPartId(null);
      setTextFieldValue(null);
      setConfirmOpenForDelete(false);
    }
  };

  return (
    <div>
      <ChildHeader text="PART LIST">
        <CustomButton
          color="primary"
          sx={{ margin: '10px', backgroundColor: '#087f5b' }}
          icon={<RiFileExcel2Line />}
          disabled={false}
          size="large"
          onClick={() => excelDownload()}
        >
          Excel Download
        </CustomButton>
      </ChildHeader>
      <SearchFilterContainer filter={true}>
        <SearchBar label="Search Part" />
        <FilterBy options={filterOptions} />
      </SearchFilterContainer>
      <TableCustom tableHeaderObj={tableHeaderObj}>
        <TableBody>
          {data &&
            data.map((item: IPart, index: number) => (
              <React.Fragment key={index}>
                <TableRow>
                  <TableCell align="center" width={10}>
                    {perPage * (+page - 1) + index + 1}
                  </TableCell>
                  <TableCell align="center">{item?.icpl_uid}</TableCell>
                  <TableCell align="center">{item?.part_number}</TableCell>
                  <TableCell align="center">{item?.part_name}</TableCell>
                  <TableCell align="center">
                    {item?.customer_id &&
                      typeof item?.customer_id !== 'string' &&
                      item.customer_id.customer_name}
                  </TableCell>
                  <TableCell align="center">{item.supplier_name}</TableCell>
                  <TableCell align="center">
                    {formatDate(item?.createdAt || '')}
                  </TableCell>
                  <TableCellStatus partId={item._id} />
                  <TableCell>
                    <Stack direction="row" sx={{ justifyContent: 'center' }}>
                      <EditIconButton
                        tooltipTitle="EDIT"
                        onClick={() => {
                          setPartId(item?._id!);
                          setIsNewPartModal(true);
                        }}
                      />
                      <ViewIconButton
                        tooltipTitle="VIEW"
                        onClick={() => {
                          navigate(
                            `/admin/ppapTiles/${item?._id}?part_name=${
                              item.part_name
                            }&part_number=${item.part_number}&customer_name=${
                              item?.customer_id &&
                              typeof item?.customer_id !== 'string' &&
                              item.customer_id.customer_name
                            }`,
                          );
                        }}
                      />
                      <DeleteIconButton
                        tooltipTitle="DELETE"
                        onClick={() => {
                          // deletePart(item?._id!);
                          setItemPartNumber(item?.part_number);
                          setPartId(item?._id!);
                          setConfirmOpenForDelete(true);
                        }}
                      />
                    </Stack>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
        </TableBody>
      </TableCustom>
      <CustomPagination totalPage={totalPages} />
      <ConfirmDialogueForInput
        title="DELETE PART"
        open={confirmOpenForDelete}
        setOpen={setConfirmOpenForDelete}
        onConfirm={handleDialogWithInput}
        isSubmitContent={false}
      >
        <p style={{ margin: 0, fontSize: '1.6rem' }}>
          Are you sure you want to delete this part?
        </p>
        <p style={{ margin: 0, fontSize: '1.6rem' }}>
          Enter the <b>Part Number :</b> "{`${itemPartNumber}`}" to confirm part
          deletion:
        </p>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          autoComplete="false"
          label="Item Number"
          type="text"
          fullWidth
          variant="standard"
          onChange={(e) => setTextFieldValue(e.target.value)}
          onPaste={(e) => {
            e.preventDefault();
            return false;
          }}
        />
      </ConfirmDialogueForInput>
      <ModalCustom
        openModal={isNewPartModal}
        closeModal={() => {
          setPartId(null);
          setIsNewPartModal(false);
        }}
        title="UPDATE PART"
      >
        <AddEditPart
          setIsNewPartModal={setIsNewPartModal}
          id={partId}
          setPartId={setPartId}
        />
      </ModalCustom>
    </div>
  );
};

export default ViewAdminPpapDoc;
